import { Fund, Provider } from '@ipensii/shared/domain-shared';
import { AbstractJsonApiService, JsonApiResourceEmptyMetadata } from './abstract-json-api.service';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { map, Observable } from 'rxjs';

export class ProvidersService extends AbstractJsonApiService<Provider> {
  constructor() {
    super('providers');
  }

  saveFundJsonApi(providerId: string, resource: Fund): Observable<JsonApiResource<Fund, JsonApiResourceEmptyMetadata>> {
    return this.http.post<JsonApiResource<Fund, JsonApiResourceEmptyMetadata>>(
      `${this.url}/${providerId}/fund`,
      resource
    );
  }

  saveFund(providerId: string, { resource }: { resource: Fund }): Observable<Fund> {
    return this.saveFundJsonApi(providerId, resource).pipe(map((res) => res.data));
  }

  deleteFundJsonApi(fundId: string) {
    return this.http.delete<JsonApiResource<Fund, JsonApiResourceEmptyMetadata>>(`${this.url}/fund/${fundId}`);
  }

  deleteFund(fundId: string) {
    return this.deleteFundJsonApi(fundId).pipe(map((res) => res.data));
  }
}
